<template>
  <div class="block-datos-resumen cl">
    <div>
      <h3 class="title">Conductor ocasional</h3>
      <dl class="contenido">
        <dt>Fecha de nacimiento:</dt>
        <dd>
          {{ resumen.conductorOcasional.fechaNacimiento | dateDDMMYYYY_slash }}
        </dd>
        <dt>Fecha de carné:</dt>
        <dd>
          {{ resumen.conductorOcasional.fechaCarne | dateDDMMYYYY_slash }}
        </dd>
        <dt>Pais obtención carné:</dt>
        <dd>{{ resumen.conductorOcasional.paisCarne }}</dd>
        <dt>Estado civil:</dt>
        <dd>{{ resumen.conductorOcasional.estadoCivil }}</dd>
        <dt>Situación Laboral:</dt>
        <dd>{{ resumen.conductorOcasional.situacionLaboral }}</dd>
        <dt>¿Es tomador?:</dt>
        <dd>{{ resumen.conductorOcasional.tomador | booleanFilter }}</dd>
        <dt>¿Es propietario?:</dt>
        <dd>{{ resumen.conductorOcasional.propietario | booleanFilter }}</dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  store: ["step"],
  props: {
    resumen: {
      type: Object
    }
  }
};
</script>

<style></style>
